"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSpacesDto = exports.UpdateSpaceDto = exports.FindResourcesOptionsDto = exports.FacilitySlotsScheduleQueryParams = exports.SaveSpaceDependenciesDto = exports.UpdateSpaceRelationshipsDto = exports.UpdateSpaceTimesDto = exports.UpdateSpacePropertiesDto = exports.CreateSpaceDto = exports.SpaceByIdDto = exports.SpaceResourceDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const resource_dto_1 = require("./resource.dto");
class SpaceResourceDto extends resource_dto_1.BaseResourceDto {
}
exports.SpaceResourceDto = SpaceResourceDto;
class SpaceByIdDto {
}
exports.SpaceByIdDto = SpaceByIdDto;
class CreateSpaceDto extends resource_dto_1.ResourceDependenciesDto {
}
exports.CreateSpaceDto = CreateSpaceDto;
class UpdateSpacePropertiesDto {
}
exports.UpdateSpacePropertiesDto = UpdateSpacePropertiesDto;
class UpdateSpaceTimesDto {
}
exports.UpdateSpaceTimesDto = UpdateSpaceTimesDto;
class UpdateSpaceRelationshipsDto {
}
exports.UpdateSpaceRelationshipsDto = UpdateSpaceRelationshipsDto;
class SaveSpaceDependenciesDto {
}
exports.SaveSpaceDependenciesDto = SaveSpaceDependenciesDto;
class FacilitySlotsScheduleQueryParams {
}
exports.FacilitySlotsScheduleQueryParams = FacilitySlotsScheduleQueryParams;
class FindResourcesOptionsDto extends general_dto_1.PaginationQuery {
}
exports.FindResourcesOptionsDto = FindResourcesOptionsDto;
class UpdateSpaceDto extends resource_dto_1.UpdateResourceDto {
}
exports.UpdateSpaceDto = UpdateSpaceDto;
class UpdateSpacesDto {
}
exports.UpdateSpacesDto = UpdateSpacesDto;
//# sourceMappingURL=space.dto.js.map